export default "__VITE_ASSET__C6rsx7RD__"